<template>
  <div class="auth-page bg-dark " id="cover">
    <b-container>
      <!-- <h5 class="auth-logo">
        <i class="fa fa-circle text-primary"></i>
        <span style="color: #fff !important">Pasargad Company (CRM) </span>
        <i class="fa fa-circle text-danger"></i>
      </h5> -->
      <Widget v-if="!steptwo" class="widget-auth mx-auto animate__animated animate__bounceInRight" :title="Header" customHeader>
        <h5 class="widget-auth-info mt-2">برای ورود ، نام کاربری و کلمه عبور را وارد کنید</h5>
        <form class="mt" @submit.prevent="GotoLogin">
          <b-alert class="alert-sm text-center mt-3" variant="danger" :show="!!errorMessage">
            {{ errorMessage }}
            <br />

            <router-link :to="{ name: 'ChekLicense' }" v-if="!isLicense"> جهت فعالسازی کلیک کنید </router-link>
          </b-alert>
          <div class="form-group mt-5">
            <input class="form-control no-border text-center" v-model="UserName" type="text" name="email" placeholder="نام کاربری" />
          </div>
          <div class="form-group">
            <input class="form-control no-border text-center" type="password" v-model="Pass" name="password" id="PassWord" placeholder="کلمه عبور" />
            <i class="fas fa-eye errspan" id="togglePassword" @click="TogglePassword"></i>
          </div>

          <div class="form-group d-flex" v-if="showCaptcha">
            <div class="form-control" id="image" selectable="False"></div>
            <p id="key"></p>
            <!-- <div id="user-input" class="inline">
              <input type="text" class="inputc"
               id="submit" placeholder="Captcha code" />
            </div> -->
            <div class="form-group">
              <input type="text" class="form-control no-border text-center" id="submit" placeholder="کد کپچا" />
              <i class="fas fa-sync errspan" @click="generate()"></i>
            </div>
          </div>

          <b-button type="submit" size="sm" class="auth-btn mt-5" variant="info" :disabled="isLogin">
            <b-spinner v-if="isLogin" small></b-spinner>
            <span class="sr-only">Loading...</span>
            ورود به سامانه
          </b-button>
          <b-button type="submit" size="sm" @click="GoToRemember()" class="auth-btn mt-2" variant="inverse">بازیابی کلمه عبور</b-button>
        </form>
        <div class="text-center mt-3">
          <span class="fas fa-server text-center" style="color: #fff !important;"></span>
          <span class="text-center" style="font-size: 10px !important ; font-family: Tahoma, sans-serif !important; color: #fff !important;" > Version : {{ $store.state.VersionSoftware }} </span>
        </div>
      </Widget>
      <Widget v-else class="widget-auth mx-auto" :title="Header" customHeader>
        <b-alert class="alert-sm text-center" variant="danger" :show="!!errorMessage">
          {{ errorMessage }}
          <!-- <br />
          <router-link :to="{ name: 'ChekLicense' }" v-if="!isLicense"> جهت فعالسازی کلیک کنید </router-link> -->
        </b-alert>
        <h5 class="widget-auth-info mt-4">کد پیامک شده به تلفن همراه خود را وارد کنید</h5>
        <div class="row px-3">
          <div class="col-12 mx-2 mt-3">
            <div class="row">
              <div class="col-3 p-1">
                <input type="number" @input="checkCode(0)" ref="code1" id="code1" v-model="code[0]" class="form-control text-center" autocomplete="off" />
              </div>
              <div class="col-3 p-1">
                <input type="number" @input="checkCode(1)" id="code2" v-model="code[1]" class="form-control text-center" autocomplete="off" />
              </div>
              <div class="col-3 p-1">
                <input type="number" @input="checkCode(2)" id="code3" v-model="code[2]" class="form-control text-center" autocomplete="off" />
              </div>
              <div class="col-3 p-1">
                <input type="number" @input="checkCode(3)" id="code4" v-model="code[3]" class="form-control text-center" autocomplete="off" />
              </div>
            </div>
            <!-- <input class="form-control text-center" v-model="twoStepCode" type="text" /> -->
          </div>
          <div class="col-12 mx-2 mt-5">
            <button class="btn btn-primary w-100" id="submitTwostep" @click="GotoLogin">تایید و ورود</button>
          </div>
        </div>
      </Widget>
    </b-container>
    <footer class="auth-footer" style="color: #fff !important">1402 &copy; طراحی و تولید شده توسط شرکت <a href="https://bnpco.ir/" style="color: #f80 !important">برنامه نویسان نو اندیش پاسارگاد</a>  - هرگونه کپی برداری تخلف محسوب می شود </footer>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget'
import { createAvatar } from '@dicebear/avatars'
import * as style from '@dicebear/avatars-identicon-sprites'
import moment from 'moment-jalaali'
export default {
  name: 'LoginPage',
  components: { Widget },
  data() {
    return {
      Header: '',
      Name: '',
      code: ['', '', '', ''],
      twoStepCode: '',
      steptwo: false,
      IP: '',
      country: '',
      Okcountry: true,
      URL: '',
      DataAxios_GetdataCustomer: { ArryfildValue: {} },
      errorMessage: null,
      Pass: '',
      UserName: '',
      info: null,
      DataAxiosGetGrpMenu: {
        ArryfildValue: '',
        Method: 'Get',
        Action: 'DefineDastresi/GetbvtblGrpCloudMenu',
        Token: this.$session.get('Token'),
      },
      UserGrpMenu: null,
      isLogin: false,
      isLicense: true,
      showCaptcha: false,
    }
  },
  methods: {
    async checkCaptcha() {
      return new Promise((resolve, reject) => {
        let apiCheck
        this.$PostData_new('get', 'Authentication/CheckCaptcha/' + this.UserName)
          .then((res) => {
            apiCheck = res
            let resolveData = false
            if (apiCheck.isSuccess) {
              resolveData = true
            } else if (this.showCaptcha == false) {
              this.showCaptcha = true
              setTimeout(() => {
                this.generate()
              }, 20)
              this.errorMessage = apiCheck.message
              // this.$mySweetDefault('', apiCheck.message, 'info', 3000)
            } else {
              let captcha = document.getElementById('image').innerHTML.toLowerCase()
              const usr_input = document.getElementById('submit').value.toLowerCase()
              if (usr_input == captcha) {
                resolveData = true
              } else {
                this.generate()
                this.errorMessage = 'کد کپچا وارد شده نادرست است'
                // this.$mySweetDefault('', 'کد کپچا وارد شده نادرست است', 'info', 3000)
              }
            }
            resolve(resolveData)
          })
          .catch((err) => {
            console.error('Captcah ERR', err)
            resolve(true)
          })
      })
    },

    checkCode(num) {
      if (this.code[num].length > 1) {
        this.code[num] = this.code[num].slice(0, 1)
      }
      if (num < 3) {
        document.getElementById('code' + (num + 2)).focus()
      } else {
        var f = document.getElementById('submitTwostep')
        f.focus()
        f.click()
      }
    },
    verifyAndEnter() {
      this.errorMessage = null
      var axios = require('axios')
      var FormData = require('form-data')
      var data = new FormData()
      this.UserName = this.UserName.replaceAll('ی', 'ي')
      this.UserName = this.UserName.replaceAll('ک', 'ك')
      data.append('UserName', this.UserName)
      data.append('Password', this.Pass)
      data.append('numIndex', -1)
      data.append('Today', moment().format('dddd'))
      data.append('IP', this.IP)
      var config = {
        method: 'post',
        url: this.URL + 'Authentication',
        headers: {},
        data: data,
        timeout: 20000,
      }
      axios(config).then((res) => {
        if (res.status == 'success') {
          this.errorMessage = res.msg
        }
      })
    },
    TogglePassword() {
      if (document.getElementById('PassWord').type == 'password') {
        document.getElementById('PassWord').type = 'text'
      } else {
        document.getElementById('PassWord').type = 'password'
      }
    },
    login() {
      const email = this.$refs.email.value
      const password = this.$refs.password.value
      if (email.length !== 0 && password.length !== 0) {
        window.localStorage.setItem('authenticated', true)
        this.$router.push('/app/dashboard')
      }
    },
    generate() {
      let captcha = document.getElementById('image')
      let uniquechar = ''
      const randomchar = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

      for (let i = 1; i < 5; i++) {
        uniquechar += randomchar.charAt(Math.random() * randomchar.length)
      }

      if (captcha != null) {
        captcha.innerHTML = uniquechar
      }
    },
    async GotoLogin() {
      try {
        if ((await this.checkCaptcha()) == false) {
          return
        }
        if (this.UserName == '' || this.Pass == '' || this.UserName == null || this.Pass == null) {
          this.errorMessage = 'نام کاربری یا کلمه عبور نمیتواند خالی باشد'
          this.isLogin = false
        } else {
          if (this.Okcountry) {
            this.isLogin = true
            var axios = require('axios')
            var FormData = require('form-data')
            var data = new FormData()
            this.UserName = this.UserName.replaceAll('ی', 'ي')
            this.UserName = this.UserName.replaceAll('ک', 'ك')
            data.append('UserName', this.UserName)
            data.append('Password', this.Pass)
            data.append('numIndex', -1)
            data.append('Today', moment().format('dddd'))
            data.append('IP', this.IP)
            if (this.steptwo) {
              this.twoStepCode = this.code[0] + this.code[1] + this.code[2] + this.code[3]
              data.append('twoStepCode', this.twoStepCode)
            }
            // console.log(this.URL, 'URLLL')
            var config = {
              method: 'post',
              url: this.URL + 'Authentication',
              headers: {},
              data: data,
              timeout: 20000,
            }
            axios(config)
              .then((res) => {
                if (res.data.status == 'NotOkLock') {
                  this.isLogin = false
                  this.errorMessage = res.data.message
                } else if (res.data.status == 'NotOk') {
                  this.isLogin = false
                  this.errorMessage = res.data.message
                } else if (res.data.status == 'success') {
                  this.steptwo = true
                  this.errorMessage = res.data.msg
                  this.isLicense = true
                } else if (res.data.status == 'Notlicense') {
                  this.isLogin = false
                  this.errorMessage = res.data.message
                  this.$session.set('Token', res.data.token)
                  this.isLicense = false
                } else {
                  this.info = res.data.data
                  // console.warn(res.data.data)
                  this.$session.start()
                  this.$session.set('Token', this.info.token)
                  this.$session.set('UserInfo', this.info)
                  this.$session.set('UserInfoPss', this.Pass)
                  let svg = createAvatar(style, {
                    seed: this.info.tblUserId,
                  })
                  var svg64 = btoa(unescape(encodeURIComponent(svg)))
                  this.$session.set('UserLogo', 'data:image/svg+xml;base64,' + svg64)
                  this.DataAxiosGetGrpMenu.ArryfildValue = { Id: this.$session.get('UserInfo').tblGrpId }
                  this.DataAxiosGetGrpMenu.Token = this.$session.get('Token')
                  this.$GetData_Header(this.DataAxiosGetGrpMenu)
                    .then((data) => {
                      this.UserGrpMenu = data
                    })
                    .finally(() => {
                      if (this.UserGrpMenu.length > 0) {
                        this.$session.set('Menu', this.UserGrpMenu)
                        for (let index = 0; index < this.UserGrpMenu.length; index++) {
                          if (this.UserGrpMenu[index].isMojaz == true) {
                            this.$store.state.ListUserGrpMenu[this.UserGrpMenu[index].RouteName] = true
                          } else {
                            this.$store.state.ListUserGrpMenu[this.UserGrpMenu[index].RouteName] = false
                          }
                        }
                        //خواندن اطلاعات مشتریان crm

                        let userCustomerCode = this.$session.get('UserInfo').userCustomerCode
                        if (userCustomerCode != 0 && userCustomerCode != null && userCustomerCode != undefined) {
                          this.DataAxios_GetdataCustomer.Action = 'CustomerInfo/Index'
                          this.DataAxios_GetdataCustomer.Method = 'post'
                          ;(this.DataAxios_GetdataCustomer.Token = this.$session.get('Token')), (this.DataAxios_GetdataCustomer.ArryfildValue.CustCode = userCustomerCode)
                          this.$PutData_Body(this.DataAxios_GetdataCustomer)
                            .then((data) => {
                              if (data.Id != null) {
                                this.$session.set('CustomerInfo', data)
                                let svgCustomer = createAvatar(style, {
                                  seed: data.CustomerCode,
                                })
                                var svg64Customer = btoa(unescape(encodeURIComponent(svgCustomer)))
                                this.$session.set('CustomerLogo', 'data:image/svg+xml;base64,' + svg64Customer)
                              }
                            })
                            .finally(() => {
                              var getUrl = this.$route.query
                              if (getUrl != null && getUrl.nextUrl != undefined) {
                                this.$router.push(getUrl.nextUrl + '')
                              } else this.$router.push('/app/dashboard')
                            })
                        } else {
                          if (this.$session.has('CustomerInfo')) {
                            this.$session.remove('CustomerInfo')
                          }
                          this.$router.push('/app/dashboard')
                        }
                        //خواندن اطلاعات مشتریان crm
                      } else {
                        this.isLogin = false
                        this.errorMessage = 'ورود ناموفق ، درحال حاضر دسترسی برای شما تعریف نشده'
                        this.$mySweetDefault('ورود ناموفق', 'در حال حاضر هیچ دسترسی برای شما تعریف نشده است ، لطفا با راهبر سیستم تماس بگیرید.', 'error', 8000)
                        this.$router.go('/')
                      }
                    })
                }
              })
              .catch((error) => {
                this.errorMessage = 'خطا در سرور!'
                this.isLogin = false
                console.error('خطا در سرور', error)
              })
          } else {
            this.errorMessage = 'امکان ورود فقط از طریق سرور های داخل ایران امکان پذیر است'
            this.isLogin = false
          }
        }
      } catch (error) {
        this.errorMessage = 'خطا در سرور!'
        this.isLogin = false
        console.error(error)
      }

      // this.$store.state.GetUserDatails = null
      // this.$store.stateTblComboGrpId45 = null
      // this.$store.stateTblComboGrpId41 = null
      // this.$store.stateTblComboGrpId42 = null
      // this.$store.stateGetCostomerProduct = null
    },
    GoToRemember() {
      this.$router.push('/RememberPassword')
    },
    emptyCombo() {
      this.$store.commit('myemptyCombo', null)
      // this.$store.state.TblComboGrpId45 = []
      // this.$store.state.GetCostomerProduct = []
      // this.$store.state.TblComboGrpId41 = []
      // this.$store.state.TblComboGrpId42 = []
    },
    GetShobe() {
      var DataAxios = { Method: 'Get', Action: 'GetBasicInfo/GetShobeDetails', ArryfildValue: null }
      this.isLogin = true
      this.$PostData(DataAxios).then((result) => {
        this.isLogin = false
        this.$session.set('CompanyLogo', result.logoUrl)
        this.$session.set('CompanyName', result.nameShobe)
        this.$session.set('CompanyNameLatin', result.nameLatinShobe)
        this.name = result.nameShobe
        this.Header = "<h3 class='mt-0'>ورود به سامانه جامع " + this.name + ' </h3>'
      })
    },
    randombg() {
      var Loc = window.location.href;
      if (Loc.indexOf("?eraseCache=true") !== -1) {
        Loc = Loc.replace("?eraseCache=true", "");
      } else if (Loc.indexOf("&eraseCache=true") !== -1) {
        Loc = Loc.replace("&eraseCache=true", "");
      }
      var random = Math.floor(Math.random() * 12) + 0;
                var bigSize = ["url('" + Loc + "/img/pic/Login/1.jpg')",
                "url('" + Loc + "/img/pic//Login/1.jpg')",
                "url('" + Loc + "/img/pic/Login/2.jpg')",
                "url('" + Loc + "/img/pic/Login/3.jpg')",
                "url('" + Loc + "/img/pic/Login/4.jpg')",
                "url('" + Loc + "/img/pic/Login/5.jpg')",
                "url('" + Loc + "/img/pic/Login/6.jpg')",
                "url('" + Loc + "/img/pic/Login/7.jpg')",
                "url('" + Loc + "/img/pic/Login/8.jpg')",
                "url('" + Loc + "/img/pic/Login/9.jpg')",
                "url('" + Loc + "/img/pic/Login/10.jpg')",
                "url('" + Loc + "/img/pic/Login/11.jpg')",
                "url('" + Loc + "/img/pic/Login/12.jpg')",
                "url('" + Loc + "/img/pic/Login/13.jpg')",
                "url('" + Loc + "/img/pic/Login/14.jpg')",
                "url('" + Loc + "/img/pic/Login/15.jpg')",
                "url('" + Loc + "/img/pic/Login/16.jpg')",
                "url('" + Loc + "/img/pic/Login/17.jpg')",
                "url('" + Loc + "/img/pic/Login/18.jpg')",
                "url('" + Loc + "/img/pic/Login/19.jpg')",
                "url('" + Loc + "/img/pic/Login/20.jpg')",
                "url('" + Loc + "/img/pic/Login/21.jpg')",
                "url('" + Loc + "/img/pic/Login/22.jpg')",
                "url('" + Loc + "/img/pic/Login/23.jpg')",
                "url('" + Loc + "/img/pic/Login/24.jpg')",
                "url('" + Loc + "/img/pic/Login/25.jpg')",
                "url('" + Loc + "/img/pic/Login/26.jpg')",
                "url('" + Loc + "/img/pic/Login/27.jpg')",
                "url('" + Loc + "/img/pic/Login/28.jpg')",
                "url('" + Loc + "/img/pic/Login/29.jpg')",
                "url('" + Loc + "/img/pic/Login/30.jpg')"];
                document.getElementById("cover").style.backgroundImage = bigSize[random];
                document.getElementById("cover").style.backgroundPosition = "center center";
                document.getElementById("cover").style.backgroundRepeat = "no-repeat";
                document.getElementById("cover").style.backgroundAttachment = "fixed";

    }
  },
  created() {
    this.$store.state.loading = false
    this.GetShobe()
    setTimeout(() => {
      this.generate()
    }, 2000)
    if (window.localStorage.getItem('authenticated') === 'true') {
      this.$router.push({
        name: 'RememberPassword',
      })
    }

    var axios = require('axios')
    var config = {
      method: 'GET',
      url: '/appSetting.json?nocache=123',
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
      },
    }
    axios(config).then((result) => {
      if (localStorage.getItem('VersionSoftwareCRM') != result.data.VersionSoftware) {
        localStorage.setItem('VersionSoftwareCRM', this.getVersionSoftware)
        this.$swal({
          title: 'بروزرسانی جدید',
          text: 'نسخه جدید در دسترس میباشد ، لطفا تایید نمایید تا نسخه شما بروزرسانی شود',
          icon: 'success',
          position: 'center',
          confirmButtonText: 'تایید',
          showConfirmButton: true,
          showCancelButton: false,
        }).then((result) => {
          if (result.isConfirmed) {
            if (this.$route.query.nextUrl != undefined && this.$route.query.nextUrl.indexOf('app/ServiceBuy') >= 0) window.location = window.location.href
            else window.location = window.location.href + '?eraseCache=true'
            // if(this.$route.query!=undefined || this.$route.query==null)
            //   window.location = window.location.href + '?eraseCache=true'
            // else
            //   window.location = window.location.href
          }
        })
      } else {
        this.URL = result.data.ApiUrl
        this.$store.state.IsActiveCash = result.data.IsActiveCash
      }
    })
    this.emptyCombo()
  },
  mounted() {
    this.randombg()
  },
  computed: {
    getVersionSoftware() {
      return this.$store.getters.getVersionSoftware
    },
  },
}
</script>
<style scoped>
.form-control {
    background: #fff !important;
    color: var(--sidebar-color-item) !important;
}
.errspan {
  float: right !important;
  margin-right: 6px !important;
  cursor: pointer !important;
  margin-top: -24px !important;
  position: relative !important;
  z-index: 2 !important;
  color: rgba(53, 30, 83, 0.719) !important;
}

#image {
  width: 30%;
  height: 40px;
  padding: 5px 15px 0px 0px;
  font-weight: 400;
  user-select: none;
  text-decoration: line-through;
  font-style: italic;
  font-size: large;
}

#user-input {
  box-shadow: 5px 5px 5px 5px gray;
  width: 40%;
  margin-right: 10px;
  padding: 10px;
  padding-bottom: 0px;
  height: 40px;
  border: red 0px solid;
}

.inputc {
  border: 1px black solid;
}

.inline {
  display: inline-block;
}

#btn {
  box-shadow: 5px 5px 5px grey;
  color: aqua;
  margin: 10px;
  background-color: brown;
}
/* @media screen and (max-width: 550px) {
  #cover{
    background-color: gray !important;
  }
} */

</style>
